// Both sections remain readable when JavaScript is unavailable.
class FCProductTabs extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.tabs = [...this.querySelectorAll('[data-fc-tab]')];
    this.panels = [...this.querySelectorAll('[data-fc-panel]')];
    const nav = this.querySelector('[data-fc-tablist]');
    if (this.tabs.length !== 2 || this.panels.length !== 2 || !nav) return;
    nav.setAttribute('role', 'tablist');
    nav.hidden = false;
    this.tabs.forEach(tab => tab.setAttribute('role', 'tab'));
    this.panels.forEach(panel => {
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', this.tabs.find(tab => tab.getAttribute('aria-controls') === panel.id).id);
      panel.tabIndex = 0;
    });
    this.addEventListener('click', event => {
      const tab = event.target.closest('[data-fc-tab]');
      if (this.tabs.includes(tab)) this.select(this.tabs.indexOf(tab));
    }, options);
    this.addEventListener('keydown', event => {
      const tab = event.target.closest('[data-fc-tab]');
      const current = this.tabs.indexOf(tab);
      if (current < 0) return;
      let next;
      if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = this.tabs.length - 1;
      if (next === undefined) return;
      event.preventDefault();
      this.select(next);
      this.tabs[next].focus();
    }, options);
    window.addEventListener('hashchange', () => this.selectHash(true), options);
    this.select(this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true') === 1 ? 1 : 0);
    this.selectHash(false);
  }
  disconnectedCallback() { this.controller?.abort(); }
  select(index) {
    this.tabs.forEach((tab, i) => {
      tab.setAttribute('aria-selected', String(i === index));
      tab.tabIndex = i === index ? 0 : -1;
      this.panels[i].hidden = i !== index;
    });
  }
  selectHash(scroll) {
    let id;
    try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
    if (!id) return;
    const target = document.getElementById(id);
    const index = this.panels.findIndex(panel => panel === target || panel.contains(target));
    if (index < 0) return;
    this.select(index);
    if (scroll) target.scrollIntoView({ block: 'start' });
  }
}
if (!customElements.get('fc-product-tabs')) customElements.define('fc-product-tabs', FCProductTabs);
